// src/modules/leads/route-planner/RoutePlannerStepIndicator.js
import React from 'react';
import { FaCheck, FaMapMarkerAlt, FaFlag, FaUsers, FaRoute, FaShareAlt } from 'react-icons/fa';
import { StepBarContainer, StepCircle, StepLine, StepLabel, StepItem } from './routePlannerStyles';

const steps = [
  { label: 'Start', icon: <FaMapMarkerAlt /> },
  { label: 'Finish', icon: <FaFlag /> },
  { label: 'Select Leads', icon: <FaUsers /> },
  { label: 'Optimize', icon: <FaRoute /> },
  { label: 'Share', icon: <FaShareAlt /> },
];

const RoutePlannerStepIndicator = ({ currentStep }) => {
  return (
    <StepBarContainer>
      {steps.map((step, index) => {
        const stepNum = index + 1;
        const status = stepNum < currentStep ? 'completed' : stepNum === currentStep ? 'active' : 'pending';

        return (
          <React.Fragment key={step.label}>
            {index > 0 && <StepLine completed={stepNum <= currentStep} />}
            <StepItem>
              <StepCircle status={status}>
                {status === 'completed' ? <FaCheck size={12} /> : step.icon}
              </StepCircle>
              <StepLabel active={status === 'active'}>{step.label}</StepLabel>
            </StepItem>
          </React.Fragment>
        );
      })}
    </StepBarContainer>
  );
};

export default RoutePlannerStepIndicator;
